import {
  createFeatureSelector,
  MemoizedSelector,
  createSelector
} from '@ngrx/store';

import * as OccupationFeatureState from './occupation.state';
import { OccupationProfileModel } from '@cpd-app/core-module/models';

export const occupationStateSlice: MemoizedSelector<
  object,
  OccupationFeatureState.OccupationState
> = createFeatureSelector<OccupationFeatureState.OccupationState>(
  OccupationFeatureState.occupationFeatureKey
);

export const getOccupationProfile: MemoizedSelector<
  object,
  OccupationProfileModel
> = createSelector(
  occupationStateSlice,
  (state): OccupationProfileModel => state.occupationProfileModel
);
